import React, { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const UnknownSelectionDisplay: FC = () => {
  return (
    <Container>
      <span>Untagged Feature</span>
      <small>Contact your Gecko representative to assign to an asset</small>
    </Container>
  )
}
